import { gql } from 'graphql-tag';

/** List maintenance or inspection templates for an asset model (type discriminates). */
export const GET_ASSET_MODEL_MAINTENANCE_TEMPLATES = gql`
  query GetAssetModelMaintenanceTemplates($assetModelId: ID!, $type: String!) {
    maintenanceTemplates(assetModelId: $assetModelId, type: $type) {
      id
      title
      type
      intervalMode
      intervalType
      intervalNumber
      intervalOperatingHours
      durationDays
      durationHours
      durationMinutes
      overdueDays
      upcomingDays
      isExternal
      isActive
      affectedComponent
      specialHint
      description
      tasks {
        id
        sortOrder
        name
        description
        type
        isMandatory
        targetValue
        referenceImages
      }
      createdAt
      updatedAt
    }
  }
`;
